<template>
  <div class="text-right"  :class="client == 'iOS' ? 'iosBox' : 'androidBox'">
    <div class="headBox">
      <header-top :text="$t('guild_self_withdraw')" :color="'#1F1315'"></header-top>
    </div>
    <div class="content-box">
      <div class="can-withdrawal">
        <span>{{$t('guild_current_withdrawable_pcoin')}}</span>
        <span>{{cin}}</span>
      </div>
      <div class="list-parent hide-scrollbar">
        <WithdrawalList :parentCoin="Number(cin.replace(/,/g, ''))"></WithdrawalList>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Popup,Loading } from "vant";
import HeaderTop from "@/components/withdrawal/top-header.vue"
import WithdrawalList from "@/components/withdrawal/withdrawal-list.vue"

export default {
  name: "self-withdrawal",
  components: {
    HeaderTop,
    WithdrawalList,
    VanPopup: Popup,
    [Loading.name]: Loading 
  },
  data() {
    return {
      client:'',
      cin:"",//余额
    };
  },
  created() {
    this.cin = this.$route.query.cin
    this.judgeClient()
  },
  mounted() {
    
  },

  methods: {
    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* .iosBox{
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top); 
} */
html[lang="ar"] .text-right{
  direction: rtl;
}
html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .txt {
  margin-right: 0.3rem;
}
.text-right{
  min-height: 100vh;
  background: #F5F6F8;
}

.meta-box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
}
.headBox{
  width: 100%;
}
.content-box{
  width: 100%;
  padding: 0 48px;
  margin-top: 32px;
  box-sizing: border-box;
}
.can-withdrawal{
  font-size: 28px;
  font-weight: 400;
  color: #262427;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 48px;
}
.can-withdrawal span:nth-of-type(2){
  font-weight: 700;
  display: flex;
  align-items: center;
}
.can-withdrawal span:nth-of-type(2)::before{
  width: 36px;
  height: 36px;
  content: "";
  background: url("../../assets/withdrawal/coin.png") no-repeat;
  background-size: 100% 100%;
}
.list-parent{
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.listBox{
  width: 100%;
  min-height: calc( 100vh - 434px);
  padding: 20px;
  box-sizing: border-box;
  border-radius: 24px 24px 0 0;
  margin-top: -20px;
  position: relative;
  background: #fff;
}
.hound {
  width: 100%;
  height: 130px;
  display: flex;
  align-items: center;
  padding-top: 30px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  box-sizing: border-box;
  position:relative;
}
.hound p {
  flex: 1;
  font-size: 30px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Mada';
}
.txt {
  width: 2rem;
  height: 0.7rem;
  margin-left: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.id {
  font-size: 0.24rem;
  font-family: Rubik;
  font-weight: 400;
  color: #acadbc;
}

/* 隐藏滚动条 */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.hide-scrollbar::-webkit-scrollbar {
    display: none; /* WebKit */
  }

</style>
